export default class BaseBoat {
  constructor(boat) {
    this.id = 'new';
    this.boatType = boat.boatType || null;
    this.status = 'DRAFT';
    this.engineType = boat.engineType || null;
    this.powerCapacity = {};
    this.cubicCapacity = {};
    this.boatSystems=[];
    this.personPowerCapacity = {};
    this.bottomContourList = [];
    this.engineTypesList = [];
    this.engineSubTypesList = [];
    this.floatationCapacity = {};
    this.boatSpecifications = {};
    this.stepValidationFunction = stepID => {
    };
  }
}

export const _initBoatSystems = (systems = []) => {
  return systems.map(system => {
    delete system.createdBy;
    delete system.creationDate;
    delete system.manufacturerCode;

    if (system.ruleValues && system.ruleValues.length) {
      system.ruleValueRequests = system.ruleValues.map(rule => {
        const componentIdWithQuantityMap = {};

        rule.ruleValueComponents.forEach(rule => componentIdWithQuantityMap[rule.componentId] = rule.quantity);

        return {
          ruleId: rule.ruleId,
          componentIdWithQuantityMap
        };
      });

      delete system.ruleValues;
    }

    if (system.optionValues) {
      system.optionValueRequests = system.optionValues.map(({optionId, value}) => ({optionId, value}));
      delete system.optionValues;
    }

    return system;
  });
};



// WEBPACK FOOTER //
// ./src/app/store/models/BaseBoat.js